import StorefrontIcon from "@mui/icons-material/Storefront";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  ThemeProvider,
  Typography,
  createMuiTheme,
  createTheme,
} from "@mui/material";
import { Formik } from "formik";
import React, { useRef, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import CheckboxCmp from "../../components/checkbox/CheckboxCmp";
import DropzoneByClick from "../../components/dropzone/DropzoneByClick";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import {
  addNewSupplierRequest,
  addNewSupplierResponse,
  users,
} from "../../models/report.model";
import { AddNewSupplier } from "../../services/report.service";
import SupplierUserForm from "../supplierUser/SupplierUserForm";

const AddNewSupplierCmp = () => {
  const [isToprated, setToprated] = useState(false);
  const [isOfflineStore, setOfflineStore] = useState(false);
  const [isOnlineStore, setOnlineStore] = useState(false);
  const [newUser, setNewUser] = useState<users[]>([]);
  const history = useHistory();
  const [logoImage, setLogoImage] = useState<any>("");
  let inputRef = useRef<HTMLInputElement>(null);

  const supplierValidation = Yup.object().shape({
    title: Yup.string()
      .ensure()
      .required("لطفا نام پذیرنده را وارد نمایید")
      .max(150, "نام پذبرنده نباید بیش از 150 کاراکتر باشد")
      .matches(/^(?!\s+$).*/, "لطفا نام پذیرنده را صحیح وارد نمایید"),

    storeTitle: Yup.string()
      .ensure()
      .matches(/^(?!\s+$).*/, "لطفا نام فروشکاه را صحیح وارد نمایید")
      .max(150, "نام فروشگاه نباید بیش از 150 کاراکتر باشد")
      .notRequired(),
    isOnlineStore: Yup.boolean(),

    websiteUrl: Yup.string()
      .ensure()
      .max(250, " وبسایت نباید بیش از 250 کاراکتر باشد")
      .when([], {
        is: () => isOnlineStore,
        then: Yup.string().required("لطفا آدرس وبسایت خود را وارد نمایید"),
        otherwise: Yup.string().notRequired(),
      })

      .matches(
        /(((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$)|(^$)/,
        "لطفا URL صحیح وارد نمایید"
      ),
  });

  let initialValues: any = {
    title: null,
    storeTitle: null,
    isTopRated: false,
    isOfflineStore: false,
    isOnlineStore: false,
    websiteUrl: null,
    logo: "",
    users: [],
  };

  const { mutate: addNewSupplier } = useMutation(AddNewSupplier, {
    onSuccess: (data: addNewSupplierResponse) => {
      if (data) {
        localStorage.setItem("SUPPLIER_ID", JSON.stringify(data));
        history.push({
          pathname: "/SuppliersList1/SuppliersListDetail",
          state: { id: data },
        });
      }
    },
    onError: () => {},
  });

  const selectLogo = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  function handleChoosedImage(image: any) {
    if (image.length !== 0) {
      setLogoImage(image[0]);
    }
  }

  return (
    <>
      <div>
        <Box
          width={"100%"}
          height={{
            xs: "fit-content",
            sm: "fit-content",
            md: "95vh",
            lg: "85vh",
          }}
          border={"2px solid #DAE0E4"}
          borderRadius={"5px"}
          padding={"2rem"}
          position={"relative"}
        >
          <Typography
            style={{
              color: "#1D4A87",
              fontSize: "18px",
              width: "fit-content",
              marginTop: "-40px",
              marginRight: "23px",
              background: "#fff",
              marginBottom: "15px",
            }}
          >
            ثبت پذیرنده جدید
          </Typography>
          <Grid
            container
            direction={"column"}
            spacing={2}
            justifyContent={"center"}
            alignItems={{ xs: "center", sm: "center", md: "start" }}
          >
            <Grid item marginBottom={"45px"} width={"100%"}>
              <Paper
                sx={{
                  backgroundColor: "#F1F4FF",
                  padding: "2rem",
                  borderRadius: "5px !important",
                  border: "none",
                }}
              >
                <Typography color={"#1D4A87"} sx={{ marginBottom: "20px" }}>
                  <WarningAmberIcon sx={{ marginLeft: "5px" }} />
                  در صورتی که گزینه فروشگاه حضوری را انتخاب کنید، افزودن لوگو،
                  نام فروشگاه و آدرس وب سایت اجباری خواهد بود .{" "}
                </Typography>
                <Typography color={"#1D4A87"} sx={{ textIndent: "25px" }}>
                  ثبت حداقل یک کاربر برای ایجاد پذیرنده جدید الزامی میباشد
                </Typography>
              </Paper>
            </Grid>
            <Grid item width={"100%"}>
              <Formik
                initialValues={initialValues}
                onSubmit={(values: addNewSupplierRequest) => {
                  values.title = values.title!.trim();
                  if (values.storeTitle) {
                    values.storeTitle = values.storeTitle!.trim();
                  }
                  values.isOfflineStore = isOfflineStore;
                  values.isOnlineStore = isOnlineStore;
                  values.isTopRated = isToprated;
                  values.users = newUser;
                  values.logo = logoImage;
                  const maxSize = 65536;

                  if (values.logo.size) {
                    if (values.logo.size > maxSize) {
                      toast.error("حجم لوگو نباید از ۱ مگابایت بیشتر باشد.");
                      return;
                    }
                  }

                  addNewSupplier(values);
                }}
                validateOnMount={true}
                validationSchema={supplierValidation}
              >
                {({
                  handleSubmit,
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <form onSubmit={handleSubmit} style={{ paddingLeft: "1rem" }}>
                    <Grid item>
                      <Grid
                        container
                        gap={"2rem"}
                        justifyContent={"start"}
                        alignItems={"end"}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={4}
                          lg={2}
                          xl={1}
                          sx={{
                            cursor: "pointer",
                          }}
                          display={"flex"}
                          justifyContent={{
                            xs: "center",
                            sm: "center",
                            md: "start",
                          }}
                        >
                          {!logoImage ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                                width: "120px",
                                height: "120px",
                                border: "2px solid #DAE0E4",
                                borderRadius: "5px",
                                padding: "5px",
                              }}
                              onClick={selectLogo}
                            >
                              <StorefrontIcon
                                style={{ fontSize: "40px", color: "#757575" }}
                              />
                              <Typography
                                fontWeight={"bold"}
                                fontSize={"14px"}
                                color={"#757575"}
                              >
                                لوگو
                              </Typography>
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                width: "120px",
                                height: "120px",
                                border: "2px solid #DAE0E4",
                                borderRadius: "5px",
                                padding: "5px",
                              }}
                              onClick={selectLogo}
                            >
                              <img
                                alt="logo"
                                src={logoImage.preview}
                                width={"100%"}
                                height={"100%"}
                                style={{ objectFit: "contain" }}
                              />
                            </Box>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                          <Grid container direction={"column"} gap={"2rem"}>
                            <Grid item>
                              <Grid container sx={{ direction: "rtl" }}>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={4}
                                  lg={2}
                                  xl={2}
                                  className="suppliers-checkbox"
                                  sx={{ marginLeft: "10px" }}
                                >
                                  <CheckboxCmp
                                    font="gap7"
                                    color="#757575"
                                    checkedColor="#1D4A87 !important"
                                    title={"پذیرنده برتر"}
                                    onBtnClick={() => {
                                      setToprated(!isToprated);
                                    }}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={4}
                                  lg={2}
                                  xl={2}
                                  className="suppliers-checkbox"
                                  sx={{ marginLeft: "10px" }}
                                >
                                  <CheckboxCmp
                                    font="gap7"
                                    color="#757575"
                                    checkedColor="#1D4A87 !important"
                                    title={"فروشگاه حضوری"}
                                    onBtnClick={() => {
                                      setOfflineStore(!isOfflineStore);
                                    }}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={4}
                                  lg={2}
                                  xl={2}
                                  className="suppliers-checkbox"
                                  sx={{ marginLeft: "10px" }}
                                >
                                  <CheckboxCmp
                                    font="gap7"
                                    color="#757575"
                                    checkedColor="#1D4A87 !important"
                                    title={"فروشگاه آنلاین"}
                                    onBtnClick={() => {
                                      setOnlineStore(!isOnlineStore);
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item>
                              <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={4}>
                                  <MaterialTextFieldComponent
                                    placeHolder={"نام پذبرنده"}
                                    label={"نام پذیرنده"}
                                    required={true}
                                    name="title"
                                    id="title"
                                    helperText={
                                      touched.title ? errors.title : ""
                                    }
                                    error={
                                      touched.title && Boolean(errors.title)
                                    }
                                    onChange={handleChange}
                                    value={values.title}
                                    onBlur={handleBlur}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}>
                                  <MaterialTextFieldComponent
                                    placeHolder={"نام فروشگاه"}
                                    label={"نام فروشگاه"}
                                    name="storeTitle"
                                    id="storeTitle"
                                    helperText={
                                      touched.storeTitle
                                        ? errors.storeTitle
                                        : ""
                                    }
                                    error={
                                      touched.storeTitle &&
                                      Boolean(errors.storeTitle)
                                    }
                                    onChange={handleChange}
                                    value={values.storeTitle}
                                    onBlur={handleBlur}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={4}
                                  className="suppliersList-newSupplier"
                                >
                                  <MaterialTextFieldComponent
                                    placeHolder={"آدرس وب سایت"}
                                    label={"آدرس وب سایت"}
                                    name="websiteUrl"
                                    id="websiteUrl"
                                    required={isOnlineStore}
                                    helperText={
                                      touched.websiteUrl
                                        ? errors.websiteUrl
                                        : ""
                                    }
                                    error={
                                      touched.websiteUrl &&
                                      Boolean(errors.websiteUrl)
                                    }
                                    onChange={handleChange}
                                    value={values.websiteUrl}
                                    onBlur={handleBlur}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={0} sm={0} md={0} lg={2} xl={3}></Grid>
                      </Grid>
                    </Grid>
                    <hr
                      style={{ background: "#C1C7CB", marginBottom: "40px" }}
                    />
                    <Grid item>
                      <Grid
                        container
                        spacing={2}
                        position={"absolute"}
                        bottom={"20px"}
                        left={{
                          xs: "0px",
                          sm: "0px",
                          md: "30px",
                          lg: "40px",
                        }}
                      >
                        <Grid item xs={0} sm={0} md={0} lg={10}></Grid>
                        <Grid item xs={12} sm={12} md={6} lg={1}>
                          <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            sx={{
                              fontWeight: "bold",
                              maxWidth: "100px",
                              borderRadius: "5px !important",
                            }}
                            disabled={!values.title || newUser!.length === 0}
                            className={
                              !values.title || newUser!.length === 0
                                ? "btnForm disabledBtn"
                                : "btnForm SuccessDefault"
                            }
                          >
                            ثبت
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={1}>
                          <Button
                            fullWidth
                            variant="contained"
                            className="cancleBtn "
                            onClick={() => history.push("/SuppliersList")}
                            sx={{ borderRadius: "5px !important" }}
                          >
                            بازگشت
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Grid>
            <Grid
              item
              width={"100%"}
              marginBottom={{
                xs: "100px",
                sm: "100px",
                md: "100px",
                lg: "0",
              }}
            >
              <SupplierUserForm newUser={newUser} setNewUser={setNewUser} />
            </Grid>
          </Grid>
        </Box>
      </div>
      <DropzoneByClick
        inputRef={inputRef}
        size={20}
        picName={"تصویر مدرک"}
        display={false}
        acceptImage={true}
        onFileChoosed={(e: any) => {
          handleChoosedImage(e);
        }}
      />
    </>
  );
};

export default AddNewSupplierCmp;
